import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    load: 'languageOnly',
    lng: 'uk',
    fallbackLng: 'uk',
    defaultNS: 'translation',
    ns: ['translation'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    react: {
      bindI18nStore: 'added',
    },
  });

export const i18n = i18next;
